import { Component } from '@angular/core';
import { 
  NavController, 
  Events,
  NavParams,
  ActionSheetController,
  ModalController
} from 'ionic-angular';

// Pages
import { InstructorAddEditPage } from '../instructors/instructor-add-edit';

// Providers
import { InstructorsService } from '../../providers/instructors/instructors-service';
import { RecertificationService } from '../../providers/instructors/recertification-service';
import { ProvidersService } from '../../providers/providers/providers-service';
import { HelperService } from '../../providers/helpers/helper-service';
import { NotificationsService } from '../../providers/notifications/notifications-service';

// Modals
import { InstructorPaymentModalPage } from '../../components/modals/instructor-payment.modal';
import moment from 'moment';

@Component({
  selector: 'page-recertification-view',
  templateUrl: 'recertification-view.html'
})

export class RecertificationViewPage {
  headerData: any;
  recertification: any = {};
  instructor: any = {};
  recordChangeAddress: boolean = false;
  recordChangeResidence: boolean = false;
  paymentBy: string = '';
  providers: any = [];
  continuingEducationRecords: any = [];
  totalCeHours: number = 0;
  lastCertDate: string;
  parentPage: any = {};

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public navParams: NavParams,
    public instructorsService: InstructorsService,
    public recertificationService: RecertificationService,
    public providersService: ProvidersService,
    public helperService: HelperService,
    private notificationsService: NotificationsService,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController
  ) {
    this.recertification = this.navParams.get('recertification');
    this.parentPage = this.navParams.get('parentPage');
    this.headerData = { title: 'Recertification Application for ' + this.recertification.first_name + ' ' + this.recertification.last_name };
    switch( this.recertification.pay_by ) {
      case 'credit_card':
        this.paymentBy = 'Credit Card';
        break;
      case 'check':
        this.paymentBy = 'Check';
        break;
      case 'invoice':
        this.paymentBy = 'Invoice';
        break;
      default:
        this.paymentBy = 'Unknown';
    }
    this.getInstructorRecord();
    this.getProviders();

    // Set employer fields.
    if ( this.recertification.employers && this.recertification.employers.length > 0 )
    {
      let employers = this.recertification.employers;
      for ( let emp of employers )
      {
        if ( emp.current_employer === 'Yes' )
        {
          this.recertification.employer_current = emp.provider_id;
        } else {
          this.recertification.employer_previous = emp.provider_id;
        }
      }
    }
  }

  getInstructorRecord()
  {
    this.recertification.registry_number = +this.recertification.registry_number;
    this.instructorsService.getInstructorByRegistryNumber( this.recertification.registry_number )
      .subscribe( data => {
        this.instructor = data;
        console.log(this.instructor);
        this.checkForRecordChanges();
        this.determineContinuingEducation();

        // Auto set expiration date for new certification.
        // We want to add 2 years (from current year) to the expiration date from the latest
        // certification. 
        //const lastCertDate = '2020-01-01';
        const lastCertDate = this.instructor.certifications[0].date_expire;
        const thisYear = moment().format('YYYY');
        const expYear = +thisYear + 2;
        const lastCertDateArray = lastCertDate.split('-');
        this.recertification.date_expire = expYear + '-' + lastCertDateArray[1] + '-' + lastCertDateArray[2];
      });
  }

  checkForRecordChanges()
  {
    // Check mailing address.
    if ( 
      this.recertification.mailing_address.toLowerCase() !== this.instructor.mailing_address.toLowerCase() ||
      this.recertification.mailing_city.toLowerCase() !== this.instructor.mailing_city.toLowerCase() ||
      this.recertification.mailing_state.toLowerCase() !== this.instructor.mailing_state.toLowerCase() ||
      this.recertification.mailing_zip.toLowerCase() !== this.instructor.mailing_zip.toLowerCase()
    )
    {
      this.recordChangeAddress = true;
    }
    // Check residence address.
    if ( 
      this.recertification.address.toLowerCase() !== this.instructor.address.toLowerCase() ||
      this.recertification.city.toLowerCase() !== this.instructor.city.toLowerCase() ||
      this.recertification.state.toLowerCase() !== this.instructor.state.toLowerCase() ||
      this.recertification.zip.toLowerCase() !== this.instructor.zip.toLowerCase()
    )
    {
      this.recordChangeResidence = true;
    }
  }

  determineContinuingEducation() 
  {
    // Find last certification date.
    let lastCertificationRecord = this.instructor.certifications[this.instructor.certifications.length - 1];
    if ( typeof lastCertificationRecord !== 'undefined' ) 
    {
      this.lastCertDate = lastCertificationRecord.date_issued;
      if ( this.lastCertDate === '0001-01-01' || this.lastCertDate === '' )
      {
        this.lastCertDate = lastCertificationRecord.date_renewed;
      }

      for( let ce of this.instructor.education )
      {
        if ( moment(ce.date_attended).isSameOrAfter( moment(this.lastCertDate) ) )
        {
          this.totalCeHours += ce.number_hours;
          this.continuingEducationRecords.push( ce );
        }
      }
    }
  }

  saveRecertification()
  {
    this.recertification.registry_number = +this.recertification.registry_number;
    this.recertificationService.saveRecertification( this.recertification )
      .subscribe( data => {
        this.events.publish('app:log', {
          message: 'Recertification record saved.',
          status: 'success',
          type: 'save recertification'
        });
      });
  }

  getProviders()
  {
    this.providersService.getProviders()
      .subscribe( data => {
        this.providers = data;
      });
  }

  approveRecertification()
  {
    // Save new instructor record information.
    this.instructor.first_name = this.recertification.first_name;
    this.instructor.last_name = this.recertification.last_name;
    this.instructor.email = this.recertification.email;
    this.instructor.phone = this.recertification.phone;

    this.instructor.mailing_address = this.recertification.mailing_address;
    this.instructor.mailing_city = this.recertification.mailing_city;
    this.instructor.mailing_state = this.recertification.mailing_state;
    this.instructor.mailing_zip = this.recertification.mailing_zip;

    this.instructor.address = this.recertification.address;
    this.instructor.city = this.recertification.city;
    this.instructor.state = this.recertification.state;
    this.instructor.zip = this.recertification.zip;

    this.instructor.addresses_same = this.recertification.addresses_same;
    
    // Instructor doesn't actually enter this info in the recertification form in the portal.
    // Not sure why we have this here.
    //this.instructor.cpr_card_expire = this.recertification.cpr_card_expire;
    //this.instructor.first_aid_card_expire = this.recertification.first_aid_card_expire;

    this.instructorsService.approveInstructorRecertification( this.instructor )
      .subscribe( data => {
        this.events.publish('app:log', {
          message: 'Aplication has been approved.',
          status: 'success',
          type: 'approve recertification'
        });

        // Update recertification record status
        this.recertification.status = 'Approved';
        this.recertificationService.saveRecertification( this.recertification )
          .subscribe( data => {
            // Save new certification record.
            let certification:any = {};
            certification.instructor_id = this.instructor.instructor_id;
            certification.date_renewed = this.helperService.getDateToday();
            certification.date_expire = this.recertification.date_expire;
            this.instructorsService.saveCertification( certification )
              .subscribe( data => {
                this.clearDashboardNotifications();
                this.parentPage.instructor.certifications.unshift(data);
                this.dismissPage();
              },
              error => {
                this.helperService.showErrors( error );
              });
          });
      },
      error => {
        this.helperService.showErrors( error );
      });    
  }

  rejectRecertification()
  {
    // Update recertification record status
    this.recertification.status = 'Rejected';
    this.recertificationService.saveRecertification( this.recertification )
      .subscribe( data => {});

    // Send rejection email
    this.recertificationService.sendRecertificationRejectionEmail( this.recertification.recertification_id )
      .subscribe( data => {
        this.events.publish('app:log', {
          message: 'Aplication has been REJECTED.',
          status: 'warning',
          type: 'reject recertification'
        });

        this.clearDashboardNotifications();
        this.dismissPage();
      });
  }

  deleteRecertification()
  {
    this.recertificationService.deleteRecertification( this.recertification.recertification_id )
    .subscribe( data => {
      this.events.publish('app:log', {
        message: 'Recertification deleted.',
        status: 'warning',
        type: 'delete recertification'
      });

      this.clearDashboardNotifications();
      this.dismissPage();
    },
    error => {
      this.helperService.showErrors( error );
    });
  }

  dismissPage()
  {
    this.navCtrl.pop();
  }

  presentDeleteRecertificationActionSheet()
  {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Are you sure you want to delete this recertification application?',
      buttons: [
        {
          text: 'Delete recertification',
          role: 'destructive',
          handler: () => {
            this.deleteRecertification();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });
    actionSheet.present();
  }

  presentRejectRecertificationActionSheet()
  {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Are you sure you want to REJECT this recertification application? Applicant will receive a rejection notice by email!',
      buttons: [
        {
          text: 'Reject recertification application',
          role: 'destructive',
          handler: () => {
            this.rejectRecertification();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });
    actionSheet.present();
  }

  presentRecertificationPaymentModalPage()
  {
    let paymentModal = this.modalCtrl.create( InstructorPaymentModalPage, {
      recertification: this.recertification
    });
    paymentModal.present();
  }

  showInstructorAddEditPage()
  {
    console.log(this.instructor);
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: this.instructor
    });
  }

  clearDashboardNotifications()
  {
    this.notificationsService.clearNotificationsByItemIdItemType(this.recertification.recertification_id, 'recertification-application')
      .subscribe(_ => {});
  }
}


// WEBPACK FOOTER //
// ./src/pages/recertifications/recertification-view.ts